import { createContext } from 'react';

/**
 * Lets route content ask the app shell to yield mobile chrome it cannot reach itself.
 *
 * "Chrome" is the UI-design term for the shell's framing elements around the content (the
 * floating trigger, headers, bars) — nothing to do with the browser.
 *
 * The floating sidebar trigger is rendered by RootLayout, far above any route-level provider, yet
 * it overlaps content that routes own — the maximised Network Overview table's title on a phone.
 * The route knows when it needs the corner back; the shell owns the trigger. This context is the
 * bridge between the two.
 */
export interface MobileChromeContextValue {
    /** True while a route has claimed the trigger's corner — the shell hides the trigger. */
    hideMobileTrigger: boolean;
    /** Claim (true) or release (false) the trigger's corner. Callers must release on unmount. */
    setHideMobileTrigger: (hidden: boolean) => void;
}

/**
 * A working default rather than null: outside the provider (tests, storybook-style islands) the
 * trigger simply stays visible and requests go nowhere, which is the pre-existing behaviour.
 */
export const MobileChromeContext = createContext<MobileChromeContextValue>({
    hideMobileTrigger: false,
    setHideMobileTrigger: () => {},
});
